import moment from "moment";
import municipalImg from "../../../src/assets/img/Group 24444.svg";
import groundImg from "../../../src/assets/img/ground_water.svg";
import rainImg from "../../../src/assets/img/Group 24445.svg";
import tankerImg from "../../../src/assets/img/Tanker.svg";

export const getDateRange = () => {
  let dateRangeArray = [];

  for (let i = 0; i <= 6; i++) {
    let currentMonthDay = moment(new Date())
      .subtract(i, "months")
      .format("YYYY-MM-DD");
    dateRangeArray.push({
      days: moment(currentMonthDay).daysInMonth(),
      end: moment(currentMonthDay).endOf("month").format("YYYY-MM-DD"),
      endText: moment(currentMonthDay).endOf("month").format("DD-MMMM-YYYY"),
      id: i + 1,
      mmt: Number(moment(currentMonthDay).format("M")),
      monthT: moment(currentMonthDay).format("MMM"),
      monthText: moment(currentMonthDay).format("MMMM"),
      start: moment(currentMonthDay).startOf("month").format("YYYY-MM-DD"),
      startText: moment(currentMonthDay)
        .startOf("month")
        .format("DD-MMMM-YYYY"),
      year: Number(moment(currentMonthDay).format("YYYY")),
    });
  }

  return dateRangeArray;
};

export const getImage = (key = "") => {
  const value = key?.toLowerCase();

  switch (true) {
    case value?.includes("municipal"):
      return {
        imgUrl: municipalImg,
        classname: "water_source_img4",
      };

    case value.includes("ground"):
      return {
        imgUrl: groundImg,
        classname: "water_source_img5",
      };

    case value.includes("rain"):
      return {
        imgUrl: rainImg,
        classname: "water_source_img3",
      };

    case value.includes("tanker"):
      return {
        imgUrl: tankerImg,
        classname: "water_source_img2",
      };

    default:
      return {
        imgUrl: tankerImg,
        classname: "water_source_img2",
      };
  }
};
